<template>
  <section :class="[$style.promo, 'container']">
    <div :class="$style.wrapper">
      <div :class="$style.promoBcg">
        <img
          src="/images/HomePromoBcg.svg"
          alt=""
        />
      </div>
      <div :class="$style.content">
        <UiIconsLogo :class="$style.logo" />
        <h1 :class="$style.title">{{ t('referral.promo.title') }}</h1>
        <div :class="$style.caption">{{ t('referral.promo.text') }}</div>
        <UiButton :to="localePath('/auth/signup')">
          <template #label>
            {{ t('referral.promo.button') }}
          </template>
          <template #preppendIcon>
            <UiIconsArrowTopRight />
          </template>
        </UiButton>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useLocalePath } from '#i18n';

const { t } = useI18n();
const localePath = useLocalePath();
</script>


<style lang="scss" module>
  .promo {
    position: relative;

    &Bcg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 48px;
      overflow: hidden;

      @media (max-width: 767px) {
        border-radius: 24px;
      }

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
  }

  .wrapper {
    position: relative;
  }

  .logo {
    width: 66px;
    height: auto;
    margin-bottom: 56px;
  }

  .content {
    z-index: 2;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 764px;
    margin: auto;
    padding: 58px 16px 86px 16px;
    color: #fff;
    text-align: center;

    @media (max-width: 1023px) {
      padding: 98px 16px 92px 16px;
    }

    @media (max-width: 767px) {
      padding: 64px 16px 210px 16px;
    }
  }

  .title {
    color: #FFF;
    text-align: center;
    font-family: 'Gilroy';
    font-size: 64px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 17px;
    margin-top: 0;

    @media (max-width: 1023px) {
      font-size: 40px;
      max-width: 584px;
      margin-left: auto;
      margin-right: auto;
    }

    @media (max-width: 767px) {
      font-size: 28px;
    }
  }

  .caption {
    margin-bottom: 56px;
    opacity: 0.8;
    max-width: 420px;

    @media (max-width: 1023px) {
      margin-bottom: 22px;
    }

    @media (max-width: 767px) {
      margin-bottom: 56px;
      max-width: 310px;
      margin-left: auto;
      margin-right: auto;
    }
  }
</style>